import { useEffect, useRef, useState } from 'react';
import { adminRoutesPrefix } from "config"
import { useLocation } from "react-router-dom"

export const useIsAdminDashboard = () => {
    const { pathname } = useLocation()
    return pathname.startsWith(adminRoutesPrefix)
}


export const useRemainingViewportHeight: () => [React.RefObject<HTMLElement>, number] = () => {
    const componentRef = useRef<HTMLElement>(null)
    const [componentHeight, setComponentHeight] = useState(0)

    useEffect(() => {
      const updateComponentHeight = () => {
        if (componentRef.current) {
          const windowHeight = window.innerHeight
          const componentPosition =
            componentRef.current.getBoundingClientRect().top
          const newComponentHeight = windowHeight - componentPosition
          setComponentHeight(newComponentHeight)
        }
      }

      window.addEventListener('resize', updateComponentHeight)
      updateComponentHeight()

      return () => {
        window.removeEventListener('resize', updateComponentHeight)
      }
    }, [])

  return [componentRef, componentHeight];
}